module.exports = __webpack_public_path__ + "static/media/1990_GDP_totalRate.da6e464c.png";